export const lightAFVariables = {};
